module.exports = __webpack_public_path__ + "img/alkalmazasok_wav.7c5afa0b.png";